"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f236 = void 0;
exports.f236 = {
    "ìzɛ": [
        192
    ],
    "ìtsà": [
        3127
    ],
    "ìdàáshà": [
        3137
    ],
    "ìjὲ": [
        3174
    ],
    "ìwhnuruòhnà": [
        3189
    ],
    "ìkàn": [
        3511
    ],
    "ìkã": [
        3511
    ]
};
